import { message } from 'antd'
import { useEffect, useRef, useState } from 'react'
import { SMS_EXPIRING } from './config'
import { matchMediaPolyfill } from './matchmedia.shim'
// import 'matchmedia-polyfill/matchMedia.addListener'

export const useLoading = (initial: boolean = false) => {
  const [loading, setLoading] = useState(initial)
  const start = () => setLoading(true)
  const finish = () => setLoading(false)

  return {
    loading,
    start,
    finish,
  }
}

export const useSMS = (service: (...arg: any[]) => Promise<any>, callback: (arg: any) => any) => {
  const { loading, start, finish } = useLoading()
  // const [remaining, setRemaining] = useState(5 * 60)
  const [remaining, setRemaining] = useState(SMS_EXPIRING)
  const sec = useRef(SMS_EXPIRING)
  const [smsSended, setSmsSended] = useState(false)
  const intervalRef = useRef<number | null>(0)

  const sendSMS = async () => {
    if (smsSended) return
    start()
    try {
      const data = await service()
      callback(data)
      setSmsSended(true)
      startInterval()
    } catch (error) {
      message.error('send sms failed: ' + error.message)
    }
    finish()
  }

  const resetInterval = () => {
    sec.current = SMS_EXPIRING
    setRemaining(SMS_EXPIRING)
    setSmsSended(false)
    clearInterval(intervalRef.current as number)
    intervalRef.current = null
  }

  const startInterval = () => {
    intervalRef.current = setInterval(() => {
      if (sec.current <= 0) {
        resetInterval()
        intervalRef.current = null
      } else {
        setRemaining((s) => s - 1)
        sec.current -= 1
      }
    }, 1000)
  }

  return {
    sending: loading,
    smsSended,
    sendSMS,
    startInterval,
    resetInterval,
    remaining,
  }
}

let needMediaPolyfill = (() => {
  if (!window.matchMedia) return true
  const mediaQueryList = matchMedia('(max-width: 600px)')

  return Object.keys(mediaQueryList).length <= 0
})()

if (needMediaPolyfill) {
  matchMediaPolyfill()
}

export const useMedia = (mediaQueryString: string, { initialMatches = true } = {}) => {
  const [matches, setMatches] = useState(initialMatches)

  useEffect(
    () => {

      if (!window.matchMedia) {
        return
      }
      const mediaQueryList = matchMedia(mediaQueryString)

      setMatches(mediaQueryList.matches)

      const handleChange = (_this: MediaQueryList, e: MediaQueryListEvent) => setMatches(e.matches)
      const handleChangeEvent = (e: any) => setMatches(e.matches)
      if (typeof mediaQueryList.addEventListener === 'function') {
        mediaQueryList.addEventListener('change', handleChangeEvent)
      } else {
        mediaQueryList.addListener(handleChange as any)
      }
      return () => {
        if (typeof mediaQueryList.removeEventListener === 'function') {
          mediaQueryList.removeEventListener('change', handleChangeEvent)
        } else {
          mediaQueryList.removeListener(handleChange as any)
        }
      }
    },
    [mediaQueryString],
  )

  return matches
}
